import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../service/ApiService';
import Pagination from '../common/Pagination';

const ManageRoomPage = () => {
    const [rooms, setRooms] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [roomsPerPage] = useState(6);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchRooms = async () => {
            try {
                const response = await ApiService.getAllRooms();
                setRooms(response.roomList);
            } catch (error) {
                console.error('Error fetching rooms:', error.message);
            }
        };
        fetchRooms();
    }, []);

    const deleteRoom = async (roomId) => {
        if (!window.confirm('Are you sure you want to delete this room?')) return;
        try {
            await ApiService.deleteRoom(roomId);
            setRooms(prev => prev.filter(room => room.id !== roomId));
        } catch (error) {
            console.error('Error deleting room:', error.message);
        }
    };

    const indexOfLastRoom = currentPage * roomsPerPage;
    const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
    const currentRooms = rooms.slice(indexOfFirstRoom, indexOfLastRoom);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className='bookings-container'>
            <h2>All Rooms</h2>
            <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                <button className="add-room-button" onClick={() => navigate('/admin/add-room')}
                    style={{ float: 'none', marginRight: 0 }}>
                    + Add New Room
                </button>
            </div>
            <div className="booking-results">
                {currentRooms.map((room) => (
                    <div key={room.id} className="booking-result-item">
                        <p><strong>Room Type:</strong> {room.roomType}</p>
                        <p><strong>Price:</strong> ${room.roomPrice} / night</p>
                        <p><strong>Description:</strong> {room.roomDescription}</p>
                        <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                            <button
                                className="edit-room-button"
                                onClick={() => navigate(`/admin/edit-room/${room.id}`)}
                            >Edit</button>
                            <button
                                className="delete-button"
                                onClick={() => deleteRoom(room.id)}
                                style={{ backgroundColor: 'red', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}
                            >Delete</button>
                        </div>
                    </div>
                ))}
            </div>
            <Pagination
                roomsPerPage={roomsPerPage}
                totalRooms={rooms.length}
                currentPage={currentPage}
                paginate={paginate}
            />
        </div>
    );
};

export default ManageRoomPage;
